export default __webpack_public_path__ + "static/media/institutes.e1f2ac42.svg";